// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__39VVe","label":"CategoryService_label__i45J2","location":"CategoryService_location__2sUmL"};